import axiosInstance from "../../api/axios";

const YoutubeService = {
  dispatchRevenueJobs: async (payload) => {
    const response = await axiosInstance.post("/v1/youtube/revenue-dispatch", payload);
    return response.data;
  },
};

export default YoutubeService;
